let debugOut = false
export default {
  created() {
		// defUIFrameColor : "#008000"
    debugOut = this.$root.$options.debugOut
  },
	mounted() {
		// defUIFrameColor : "#008000"
    window.onkeydown = function(e) {
      // if (debugOut) {console.log(e)}
      if (e.code == 'Tab') {
        if (debugOut) {console.log('void tab key!')}
        return false; // Disable Tab!
      }
    };
    if (this.$root.documentAreaHeight == undefined) {
      this.updateDocumentAreaWH()
    }
  },
  props: {

  },
  watch: {
    '$route' (to, from) {
      if ((to.meta.title !== from.meta.title) || (to.meta.desc !== from.meta.desc)) this.createPageTitle(to)
    }
  },
  data() {
    return {
      //  //
      // tempTentativeSize: tempTentativeSize,
      // rubySize: rubySize,
      // charSpacing:charSpacing,
      // lineSpacing:lineSpacing,
      // hantWidthRatio:hantWidthRatio,
      // TagCmds:TagCmds,
      // LineStyle:LineStyle,
      // WordType:WordType,
      // WordTypeMask:WordTypeMask,
      // VerticalOpe:VerticalOpe,
      // PropFlag:PropFlag,
      // //  //

    };
  },
  methods: {
		isNumber(val) {
			var regex = new RegExp(/^[-+]?[0-9]+(\.[0-9]+)?$/);
			return regex.test(val.toString());
		},
    toPX(val,parent) {
      let items = /(\d+\.?\d*)(\D*)/ig.exec(val);
      if (items.length < 2 || items.length > 3) return parseFloat(val);
      if (items.length > 3) return val;
      let num = null;
      if (items.length > 1) num = items[1];
      if (!this.isNumber(num)) return val;
      num = parseFloat(num);
      let unit = items[2];
      switch (unit) {
        case 'px':
          return num;
        case '%':
          return num / 100 * parent;
        case 'vw':
          return num / 100 * document.documentElement.clientWidth;
        case 'vh':
          return num / 100 * document.documentElement.clientHeight;
        case 'vmin':
          return num / 100 * (document.documentElement.clientWidth < document.documentElement.clientHeight ? document.documentElement.clientWidth : document.documentElement.clientHeight); ;
        case 'vmax':
          return num / 100 * (document.documentElement.clientWidth > document.documentElement.clientHeight ? document.documentElement.clientWidth : document.documentElement.clientHeight); ;
      }
    },
    calcTextWidth(text,font) {
      let offcvs = document.createElement("canvas")
      offcvs.width = 128
      offcvs.height = 40
      let ctx = offcvs.getContext("2d")
      if (font) {
        ctx.font = font
      }
      ctx.beginPath()
      let measure = ctx.measureText(text)
      return measure.width
    },
    updateDocumentAreaWH() {
      let el = document.getElementById('app')
      if (el === undefined) {
        if (debugOut) {console.log('root element get failed.')}
        return
      }
      this.$store.commit('setDocumentArea',el)
      if (debugOut) {console.log(`docarea: ${this.$store.state.documentAreaWidth} x ${this.$store.state.documentAreaHeight}`)}
    },
    makeSVGImage(svg) {
      return new Promise(async (resolve, reject) => {
        let image = new Image()
        image.addEventListener("load", () => {
          resolve(image)
        }, true)
        image.onerror = () => {
          reject('Image set failed!')
        }
        image.src = "data:image/svg+xml;charset=utf-8;base64," + btoa(svg)
      })
    },
    createPageTitle(to) {
      // タイトルを設定
      if (to.meta.title) {
        var setTitle = to.meta.title + ' | Choiyomi';
        document.title = setTitle;
      } else {
        document.title = 'Choiyomi'
      }

      // メタタグdescription設定
      if (to.meta.desc) {
        var setDesc = to.meta.desc + ' | Choiyomi';
        document.querySelector("meta[name='description']").setAttribute('content', setDesc)
      } else {
        document.querySelector("meta[name='description']").setAttribute('content', 'Choiyomi')
      }
    }
  },
  computed: {
		defUIFrameColor() { return "#9B9B9B" },
		defUIHighlightColor() { return "#FF0000" },
		defUIBackColor() { return "none" },
		defUIBackPushColor() { return "#AAAAAA" },
		defUIIconColor() { return "#8B572A" },
		defUIFrameDisColor() { return "#E8E8E8" },
		defUIBackDisColor() { return "none" },
		defUIIconDisColor() { return "#D0D0D0" },
  }
}

